export { default } from "./RegistroMovimientosCajasVentas";
